import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import Vant from "vant";
import store from "./store";
import "vant/lib/index.less";
import "normalize.css";
import "./theme/common.less";
import "./theme/main.css"; // 导入 main.css
import { MyRouter } from "./utils/goRouter";
import mixin from "./mixins/mixin.js";

Vue.use(require("vue-wechat-title"));
// 引入微信SDK
import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;
Vue.prototype.uni = MyRouter;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

console.log("当前环境：" + process.env.NODE_ENV);
Vue.use(Vant);

import Vconsole from "vconsole";
if (process.env.NODE_ENV !== "production") {
  let dConsole = new Vconsole();
  Vue.use(dConsole);
}

// 上线前一定要删除;
if (
  process.env.NODE_ENV !== "testing" &&
  process.env.NODE_ENV !== "production"
) {
  document.cookie = "JSESSIONID=1&57e43f28f1ed4afc947979604a157cb2";
}

Vue.config.productionTip = false;
// 全局mixin
Vue.use(mixin);
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
